<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div class="scan-detail">
    <div class="scan-detail-title">
      <h3 class="scan-detail-title-h3">
        <a @click="goBackScan">{{ $t('scanAnalysis.title') }}</a> >
      </h3>
      <Dropdown
        trigger="click"
        class="scan-detail-title-dropdown"
        @on-click="updateQcode">
          <a
            href="javascript:void(0)"
            class="scan-detail-title-dropdown-name">
              <p style="float:left; margin:0 8px;">
                <span>{{ $t('scanDetail.qcode') }}</span>
                {{ currentQcodeNm }}
              </p>
              <Icon type="ios-arrow-down" size="16"></Icon>
          </a>
          <Dropdown-menu
            class="scan-detail-title-dropdown-ul"
            slot="list">
            <Dropdown-item
              v-for="(eachQcode, index) in qcodeList"
              :key="eachQcode.qcodeId"
              :name="index">
              {{ eachQcode.qcodeNm }}
            </Dropdown-item>
          </Dropdown-menu>
      </Dropdown>
    </div>
    <div class="scan-detail-overview">
      <panelMove
        :userCount="overviewMetrics.scanTimes.currentValue"
        :tooltipTitle="$t('scanDetail.overview.scanTimes')"
        :tooltipContent="$t('scanAnalysis.explain.scanTimes')"
        :userPro="overviewMetrics.scanTimes.changePer">
      </panelMove>
      <panelMove
        :userCount="overviewMetrics.scanDevs.currentValue"
        :tooltipTitle="$t('scanDetail.overview.scanDevs')"
        :tooltipContent="$t('scanAnalysis.explain.scanDevs')"
        :userPro="overviewMetrics.scanDevs.changePer">
      </panelMove>
      <panelMove
        :userCount="overviewMetrics.newDevs.currentValue"
        :tooltipTitle="$t('scanDetail.overview.newDevs')"
        :tooltipContent="$t('scanAnalysis.explain.newDevs')"
        :userPro="overviewMetrics.newDevs.changePer">
      </panelMove>
      <panelMove
        :userCount="overviewMetrics.ratio.currentValue"
        :tooltipTitle="$t('scanDetail.overview.per')"
        :tooltipContent="$t('scanAnalysis.explain.ratio')">
      </panelMove>
    </div>
    <div class="scan-detail-chart">
      <div class="scan-detail-chart-trend">
        <!-- 趋势分析下载及指标说明 -->
        <Row class-name="scan-detail-chart-title">
          <Col span="12" class-name="scan-detail-chart-title-h3">
            {{ $t('scanDetail.trend') }}：
            <span>{{ currentQcodeNm }}</span>
          </Col>
          <Col span="12" class-name="scan-detail-chart-title-details">
            <Poptip trigger="hover" class="tab-pop" placement="bottom-end">
              <span
                class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
                style="margin-left:10px;">
              </span>
              <div slot="title">{{ $t('sceneAnalysis.explain.title') }}</div>
              <div slot="content">
                <p>
                  <span>{{ $t('scanAnalysis.overview.scanTimes') }}: </span>
                  {{ $t('scanAnalysis.explain.scanTimes') }}
                </p>
                <p>
                  <span>{{ $t('scanAnalysis.overview.scanDevs') }}: </span>
                  {{ $t('scanAnalysis.explain.scanDevs') }}
                </p>
                <p>
                  <span>{{ $t('scanAnalysis.overview.newDevs') }}: </span>
                  {{ $t('scanAnalysis.explain.newDevs') }}
                </p>
              </div>
            </Poptip>
          </Col>
        </Row>
        <Tabs
          :value="scanDetailTab"
          @on-click="onChangeTabs">
          <Tab-pane :label="$t('scanAnalysis.scanTimes.tabs')" name="scanTimes">
            <chart-move
              :show-transform="false"
              chart-name="scanTimesChart"
              parent-string="scanDetail"
              ref="scanTimes">
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.scanTimes.totalTimes') }}</span>
                  <b>{{ scanTimes.totalVolumn | numberSeparator }}</b>
                </div>
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.scanTimes.dayAvgTimes') }}</span>
                  <b>{{ scanTimes.avgVolumn | numberSeparator }}</b>
                </div>
            </chart-move>
          </Tab-pane>
          <Tab-pane :label="$t('scanAnalysis.scanDevs.tabs')" name="scanDevs">
            <chart-move
              :show-transform="false"
              chart-name="scanDevsChart"
              parent-string="scanDetail"
              ref="scanDevs">
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.scanDevs.totalDev') }}</span>
                    <b>{{ totalScanDev | numberSeparator }}</b>
                </div>
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.scanDevs.dayAvgDev') }}</span>
                    <b>{{ averageScanDev | numberSeparator }}</b>
                </div>
            </chart-move>
          </Tab-pane>
          <Tab-pane :label="$t('scanAnalysis.newDevs.tabs')" name="newDevs">
            <chart-move
              :show-transform="false"
              chart-name="newDevsChart"
              parent-string="scanDetail"
              ref="newDevs">
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.newDevs.totalNewDev') }}</span>
                  <b>{{ newDevs.totalVolumn | numberSeparator }}</b>
                </div>
                <div class="chart-move-metrice-title" slot="chart-move-metrice">
                  <span>{{ $t('scanAnalysis.newDevs.dayAvgNewDev') }}</span>
                  <b>{{ newDevs.avgVolumn | numberSeparator }}</b>
                </div>
            </chart-move>
          </Tab-pane>
        </Tabs>
      </div>
      <div class="scan-detail-chart-table">
        <Row
          class-name="scan-detail-chart-title"
          style="border-bottom: none;">
          <Col span="12" class-name="scan-detail-chart-title-h3">
            {{ $t('scanDetail.detail') }}：
            <span>{{ currentQcodeNm }}</span>
          </Col>
          <Col span="12" class-name="scan-detail-chart-title-details">
            <a @click="goEditPage">{{ $t('scanAnalysis.createCode') }}</a>
            <span
              class="iconfont icon-download tm-icon-font hover-style tm-icon-font-portrait"
              @click="exportData('detail')">
            </span>
          </Col>
        </Row>
        <table-move
          style="min-height:500px;"
          v-if="tableColumn.length > 0"
          :noData="pageNoData"
          :change-data="tableData"
          :table-columns="tableColumn"
          ref="detail"
          @on-table-move-sort="sortTable">
        </table-move>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import panelMove from '../../components/panel-move/index';
  import chartMove from '../../components/chart-move/chart-move';
  import tableMove from '../../components/table-move/table-move';
  import numberSeparator from '../../filters/number-separator';
  import baseFn from '../../components/chart-move/chart-base';
  import sortData from '../../filters/sort-table-data';
  import bus from '../../libs/bus';
  import util from '../../libs/util';

  export default {
    data() {
      const self = this;
      const qcodeInfo = JSON.parse(sessionStorage.getItem('qcodeAnalysis'));
      return {
        scanDetailTab: 'scanTimes',
        overviewMetrics: {
          scanTimes: {
            currentValue: '--',
            changePer: '--',
          },
          scanDevs: {
            currentValue: '--',
            changePer: '--',
          },
          newDevs: {
            currentValue: '--',
            changePer: '--',
          },
          ratio: {
            currentValue: '--',
          },
        },
        // 扫码趋势前后端接口指标
        trendAPIMetrics: {
          FE: ['scanTimes', 'scanDevs', 'newDevs'],
          BE: ['scanQcodeAmt', 'scanQcodeDeviceAmt', 'newScanQcodeDeviceAmt'],
        },
        scanTimes: { // the metadata of scanTimes tab
          show: false,
          legendName: ['totalTimes'],
          totalVolumn: '--',
          avgVolumn: '--',
        },
        scanDevs: { // the metadata of scanDevs tab
          show: false,
          legendName: ['totalDev'],
          totalVolumn: '--',
          avgVolumn: '--',
        },
        newDevs: { // the metadata of newDevs tab
          show: false,
          legendName: ['totalNewDev'],
          totalVolumn: '--',
          avgVolumn: '--',
        },
        tableColumn: self.setTableColumns(),
        tableData: [],
        dayDiff: 0,
        currentQcodeId: qcodeInfo ? qcodeInfo.qcodeid : '',
        currentQcodeNm: qcodeInfo ? qcodeInfo.qcodename : '',
        qcodeList: qcodeInfo ? qcodeInfo.qcodeList : [],
        pageNoData: this.$t('common.loading'),
      };
    },
    computed: {
      totalScanDev() {
        return this.overviewMetrics.scanDevs.currentValue;
      },
      averageScanDev() {
        return (this.overviewMetrics.scanDevs.currentValue /
          this.dayDiff).toFixed(2);
      },
    },
    mounted() {
      bus.$on('on-app-change', () => {
        this.init();
      });
      bus.$on('on-platform-change', () => {
        this.init();
      });
      bus.$on('on-conditions-change', () => {
        this.init();
      });
      bus.$on('on-date-change', () => {
        this.init();
      });
      bus.$on('on-change-lang', () => {
        this.tableColumn = this.setTableColumns();
      });
      if (!bus.productInfo.productid) {
        return;
      }
      this.init();
    },
    beforeDestroy() {
      bus.$off('on-app-change');
      bus.$off('on-platform-change');
      bus.$off('on-conditions-change');
      bus.$off('on-date-change');
      bus.$off('on-change-lang', () => {
        this.tableColumn = this.setTableColumns();
      });
    },
    methods: {
      init() {
        this.clearData(); // 初始化数据
        Object.keys(this.$refs).forEach((x) => {
          if (this.$refs[x].clearData) this.$refs[x].clearData();
        });
        // 获取并并设置头部指标
        this.getParallelOverview();
        // 初始化chart-move组件数据
        this.onChangeTabs(this.scanDetailTab); // 初始化tabs组件的第一个tab
        this.setTableData();
      },
      /**
       * 并行的发送当前和上个周期的请求
       */
      getParallelOverview() {
        const curStartDay = bus.selectedDate[0].split('-').join('').slice(2);
        const curEndDay = bus.selectedDate[1].split('-').join('').slice(2);
        const [preStartDay, preEndDay] =
          this.calculateComparedTime(bus.selectedDate[0], bus.selectedDate[1]);
        axios.all([this.getOverviewMetrics(curStartDay, curEndDay),
          this.getOverviewMetrics(preStartDay, preEndDay)])
          .then(axios.spread((curData, preData) => {
            this.setOverviewMetrics(curData, preData);
          }))
          .catch(() => {
            this.$Message.error({
              content: this.$t('scanAnalysis.error'),
              duration: 3,
            });
          });
      },
      /**
       * 计算环比周期的起止日期
       * @param  {[Sting]} start   [起始日期]
       * @param  {[Sting]} end   [终止日期]
       */
      calculateComparedTime(start, end) {
        const endTime = new Date(end).getTime();
        const startTime = new Date(start).getTime();
        const timeDiff = endTime - startTime;
        const preEndDay = new Date(endTime - timeDiff);
        const preStartDay = new Date(startTime - timeDiff);
        const formatPreEndDay = this.getFormatDate(preEndDay);
        const formatPreStartDay = this.getFormatDate(preStartDay);
        return [formatPreStartDay, formatPreEndDay];
      },
      /**
       * 格式化date字符串
       */
      getFormatDate(date) {
        const year = date.getFullYear();
        let month = date.getMonth() + 1;
        if (month < 10) {
          month = `0${month}`;
        }
        let day = date.getDate();
        if (day < 10) {
          day = `0${day}`;
        }
        return `${year}${month}${day}`.slice(2);
      },
      /**
       * 获取overview指标
       * @param  {[Sting]} startDay   [起始日期]
       * @param  {[Sting]} endDay   [终止日期]
       */
      getOverviewMetrics(startDay, endDay) {
        // startDay, endDay构建请求体
        const params = this.getCommonRequestBody();
        params.startTime = startDay;
        params.endTime = endDay;
        params.metrics = ['scanQcodeAmt', 'scanQcodeDeviceAmt', 'newScanQcodeDeviceAmt', 'totalViewAmt'];
        params.qcodeId = this.currentQcodeId;
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 设置overview指标
       * @param  {[Array]} curData   [当前值]
       * @param  {[Array]} preData   [上个周期值]
       */
      setOverviewMetrics(curData, preData) {
        this.overviewMetrics.scanTimes.currentValue = curData.scanQcodeAmt[0].value;
        this.overviewMetrics.scanDevs.currentValue = curData.scanQcodeDeviceAmt[0].value;
        this.overviewMetrics.newDevs.currentValue = curData.newScanQcodeDeviceAmt[0].value;
        if (curData.totalViewAmt[0].value > 0) {
          this.overviewMetrics.ratio.currentValue =
            (100 * (curData.scanQcodeAmt[0].value / curData.totalViewAmt[0].value)).toFixed(2);
        } else {
          this.overviewMetrics.ratio.currentValue = (0).toFixed(2);
        }
        this.overviewMetrics.ratio.currentValue = `${this.overviewMetrics.ratio.currentValue}%`;
        // 设置变化趋势
        this.overviewMetrics.scanTimes.changePer =
          this.calculatePer(curData.scanQcodeAmt[0].value, preData.scanQcodeAmt[0].value);
        this.overviewMetrics.scanDevs.changePer =
          this.calculatePer(curData.scanQcodeDeviceAmt[0].value, preData.scanQcodeDeviceAmt[0].value);
        this.overviewMetrics.newDevs.changePer =
          this.calculatePer(curData.newScanQcodeDeviceAmt[0].value,
            preData.newScanQcodeDeviceAmt[0].value);
      },
      /**
       * 计算指标的相对变化百分比
       * @param  {[Number]} curValue   [当前值]
       * @param  {[Sting]} preValue   [上个周期值]
       */
      calculatePer(curValue, preValue) {
        let per;
        if (preValue !== 0) {
          per = (100 * ((curValue - preValue) / preValue)).toFixed(2);
        } else {
          per = '--';
        }
        return per === 'NaN' || per === 'Infinity' ? '--' : per;
      },
      /**
       * 返回上一级
       */
      goBackScan() {
        this.$router.go(-1);
      },
      /**
       * 获取http请求体的公共字段
       */
      getCommonRequestBody() {
        const conditions = bus.conditions;
        const params = {
          developerId: bus.developerid.toString(),
          productId: bus.productInfo.productid,
          platformIds: bus.platform, // Array
          partnerIds: conditions.partner.length === 0 ? undefined : conditions.partner, // Array
          versions: conditions.version.length === 0 ? undefined : conditions.version, // Array
          startTime: bus.selectedDate[0].split('-').join('').slice(2),
          endTime: bus.selectedDate[1].split('-').join('').slice(2),
        };
        return params;
      },
      /**
       * Tabs 切换事件
       * @param  {[String]} key [点击的 Tabs 名称]
       */
      onChangeTabs(key) {
        this.scanDetailTab = key;
        if (this[key].show) return; // if click on the current tab just return
        // 定义图表图例名称
        const legendName = this[key].legendName.map(() => this.$t(`scanAnalysis.${key}.tabs`));
        // 定义chart数据
        const chart = {
          legendName,
          xaxisData: [],
          yaxis: [],
          series: [],
        };
        this.getScanTrendData(key).then((res) => {
          // 根据不同的metric取得相应的数据
          const metric = this.trendAPIMetrics.BE[this.trendAPIMetrics.FE.indexOf(key)];
          const trendData = res[metric];
          // 计算图表的总访问次数和日均访问次数指标
          [this[key].totalVolumn, this[key].avgVolumn] =
            this.calculateTrendMetrics(trendData);
          chart.yaxis = [baseFn.setyAxisStyle('')];
          chart.xaxisData = trendData.map(eachDay => eachDay.tag);
          chart.series = {
            name: legendName,
            type: 'line',
            smooth: true,
            data: trendData.map(eachDay => eachDay.value),
          };
          this.setOverviewData(key, chart);
        })
        .catch(() => {
          this.pieChartErrorView(key);
        });
      },
      /**
       * 计算趋势曲线的指标数据：总量和日均量
       * @param  {[Array]} key [每日趋势数据]
       */
      calculateTrendMetrics(trendData) {
        let eachDaySum = 0;
        trendData.forEach((eachDay) => {
          eachDaySum += eachDay.value;
        });
        const endTime = new Date(bus.selectedDate[1]).getTime();
        const startTime = new Date(bus.selectedDate[0]).getTime();
        let dayDiff = (endTime - startTime) / (1000 * 3600 * 24);
        dayDiff += 1;
        this.dayDiff = dayDiff;
        const average = (eachDaySum / dayDiff).toFixed(2);
        return [eachDaySum, average];
      },
      /**
       * 数据请求失败图表提示
       * @param {[String]} key   [当前 tabs标示]
       */
      pieChartErrorView(key) {
        this.$refs[key].spinShow = false;
        this.$refs[key].errorSpin = true;
      },
      /**
       * 获取趋势图表数据
       * @param {[String]} metric   [当前 tabs标示]
       */
      getScanTrendData(metric) {
        // 利用metric构造不同的请求体
        const params = this.getCommonRequestBody();
        const curIndex = this.trendAPIMetrics.FE.indexOf(metric);
        params.metrics = [this.trendAPIMetrics.BE[curIndex]];
        params.qcodeId = this.currentQcodeId;
        params.groupBy = 'day';
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      getTableData() {
        // 利用构造请求体
        const params = this.getCommonRequestBody();
        params.metrics = ['scanQcodeAmt', 'scanQcodeDeviceAmt', 'newScanQcodeDeviceAmt'];
        params.groupBy = 'day';
        params.aggr = '1';
        params.qcodeId = this.currentQcodeId;
        return util.ajax.post('/app/rest/miniApp/query', params);
      },
      /**
       * 设置详情table数据
       */
      setTableData() {
        const self = this;
        self.getTableData().then((res) => {
          res.forEach((eachDay) => {
            self.tableData.push({
              date: eachDay.day,
              scanTimes: eachDay.scanQcodeAmt,
              scanDev: eachDay.scanQcodeDeviceAmt,
              scanPerDev: eachDay.scanQcodeDeviceAmt === '0' ? 0 :
                (eachDay.scanQcodeAmt / eachDay.scanQcodeDeviceAmt).toFixed(2),
              newDev: eachDay.newScanQcodeDeviceAmt,
            });
          });
        })
        .catch(() => {
          this.$Message.error({
            content: this.$t('scanAnalysis.error'),
            duration: 3,
          });
        });
      },
      /**
       * 将数据传递到图表组件
       * @param {[String]} key   [当前 tabs标示]
       * @param {[Object]} chart [当前 tabs chart 数据]
       * @param {[String]} stack [当前 tabs stack 标示(堆积图标示)]
       */
      setOverviewData(key, chart) {
        const refsDom = this.$refs[key];
        this[key].show = true;
        refsDom.spinShow = false;
        // refsDom.initTable(table.columns, table.data);
        refsDom.initChart(chart.legendName, chart.xaxisData, chart.yaxis, chart.series);
      },
      /**
       * 下载图表数据
       * @param  {[Sting]} str   [当前 Tabs 标示]
       */
      exportData(str) {
        const arg = str;
        this.$refs[arg].exportTable(this.currentQcodeNm);
      },
      goEditPage() {
        this.$router.push({
          name: 'qrCode',
          params: {
            productid: this.$route.params.productid,
          },
        });
      },
      /**
       * 自定义排序
       * @param  {[Object]} obj [点击排序列内容]
       * @param {String} name [table-move 绑定的refs 表格数据前缀 例：ref为pageTable，则此表格绑定数据为pageTableData]
       */
      sortTable(obj, tableData) {
        const data = tableData;
        const list = sortData(obj, data);
        this.tableData = list;
      },
      clearData() {
        this.scanTimes = { // the metadata of scanTimes tab
          show: false,
          legendName: ['totalTimes'],
          totalVolumn: '--',
          avgVolumn: '--',
        };
        this.scanDevs = { // the metadata of scanDevs tab
          show: false,
          legendName: ['totalDev'],
          totalVolumn: '--',
          avgVolumn: '--',
        };
        this.newDevs = { // the metadata of newDevs tab
          show: false,
          legendName: ['totalNewDev'],
          totalVolumn: '--',
          avgVolumn: '--',
        };
        this.tableData = [];
        this.overviewMetrics = {
          scanTimes: {
            currentValue: '--',
            changePer: '--',
          },
          scanDevs: {
            currentValue: '--',
            changePer: '--',
          },
          newDevs: {
            currentValue: '--',
            changePer: '--',
          },
          ratio: {
            currentValue: '--',
          },
        };
        this.dayDiff = 0;
      },
      updateQcode(index) {
        this.currentQcodeNm = this.qcodeList[index].qcodeNm;
        this.currentQcodeId = this.qcodeList[index].qcodeId;
        sessionStorage.setItem('qcodeAnalysis', JSON.stringify({
          qcodeid: this.currentQcodeId,
          qcodename: this.currentQcodeNm,
          qcodeList: this.qcodeList,
        }));
        this.init();
      },
      setTableColumns() {
        const self = this;
        return [
          {
            title: self.$t('scanDetail.tableColumn.date'),
            key: 'date',
            sortable: true,
          },
          {
            title: self.$t('scanDetail.tableColumn.scanTimes'),
            key: 'scanTimes',
            align: 'right',
          },
          {
            title: self.$t('scanDetail.tableColumn.scanDevs'),
            key: 'scanDev',
            align: 'right',
          },
          {
            title: self.$t('scanDetail.tableColumn.scanTimesPerDev'),
            key: 'scanPerDev',
            align: 'right',
          },
          {
            title: self.$t('scanDetail.tableColumn.newDevs'),
            key: 'newDev',
            align: 'right',
          },
        ];
      },
    },
    components: {
      panelMove,
      chartMove,
      tableMove,
    },
    filters: {
      numberSeparator,
      sortData,
    },
  };
</script>
